import React, { PureComponent, Fragment } from 'react';
import ENUMS from '../../../enums';
import { enumHelper } from '../../../utils';
import DeleteConfirm from '../../../components/DeleteConfirm';
import Select from 'react-select';

export default class TablesList extends PureComponent {
  state = {
    tables: [],
    displayDeleteConfirm: false,
    selectedItemKeyForDelete: null,
    isTableDeletedStyle: '',
  };

  componentDidUpdate() {
    this.setState(() => ({
      tables: this.props.tables,
    }));
  }

  deleteAlreadySelectedItem = (status, tableKey) => {
    let tables = this.state.tables;
    this.state.tables.find(item => {
      item.itemKey === tableKey &&
        (tables = [...tables, item.isDeleted === true]);
    });
    this.props.deleteTableItem(status, tableKey);
  };

  onDeleteItem = (itemKey, num) => {
    this.setState(() => ({
      displayDeleteConfirm: true,
      selectedItemKeyForDelete: itemKey,
      selectedItemTitleForDelete: 'میز شماره ' + num,
    }));
  };

  onEditItem = itemKey => {
    this.props.displayEditTableItemModal(itemKey);
  };

  closeDeleteTableItemModal = () => {
    this.setState(() => ({
      selectedItemKeyForDelete: null,
      displayDeleteConfirm: false,
    }));
  };

  render() {
    return (
      <Fragment>
        <table
          className={`table table-striped table-bordered text-muted ${this.props
            .cafeType === 'NORMAL' && 'table-hover'}`}
        >
          <thead>
            <tr>
              <th className='text-center'>{locales('tables.row')}</th>
              <th className='text-center'>{locales('fields.table.no')}</th>
              <th className='text-center'>{locales('table.title')}</th>
              <th className='text-center'>{locales('fields.floor')}</th>
              <th className='text-center'>{locales('fields.area')}</th>
              <th className='text-center'>
                {locales('fields.table.numberOfChairs')}
              </th>
              <th className='text-center'>{locales('tables.isSmoking')}</th>
              <th className='text-center'>{locales('fields.heatSystem')}</th>
              <th className='text-center'>{locales('fields.coolingSystem')}</th>
              <th className='text-center'>
                {locales('fields.fogCoolingSystem')}
              </th>
              <th className='text-center'>{locales('inputAmount')}</th>
              <th className='text-center' colSpan='2'></th>
            </tr>
          </thead>
          <tbody>
            {this.state.tables &&
              this.state.tables
                .sort((a, b) => a.num - b.num)
                .map((tableItem, index) => {
                  return (
                    <tr
                      key={tableItem.itemKey}
                      disabled={tableItem.isDeleted}
                      className={tableItem.isDeleted ? 'table-is-deleted' : ''}
                    >
                      <td
                        className={
                          'text-center ' +
                          (tableItem.isDeleted ? 'text-warning' : '')
                        }
                      >
                        {index + 1}
                      </td>
                      <td
                        className={
                          'text-center ' +
                          (tableItem.isDeleted ? 'text-warning' : '')
                        }
                      >
                        {tableItem.num}
                      </td>
                      <td
                        className={
                          'text-center ' +
                          (tableItem.isDeleted ? 'text-warning' : '')
                        }
                      >
                        {tableItem.tableTitle}
                      </td>
                      <td
                        className={
                          'text-center ' +
                          (tableItem.isDeleted ? 'text-warning' : '')
                        }
                      >
                        {enumHelper.convertEnumValueToTitle(
                          ENUMS.TABLE_FLOORS.list,
                          tableItem.floor,
                        )}
                      </td>
                      <td
                        className={
                          'text-center ' +
                          (tableItem.isDeleted ? 'text-warning' : '')
                        }
                      >
                        {enumHelper.convertEnumValueToTitle(
                          ENUMS.TABLE_LOCATIONS.list,
                          tableItem.location,
                        )}
                      </td>
                      <td
                        className={
                          'text-center ' +
                          (tableItem.isDeleted ? 'text-warning' : '')
                        }
                      >
                        {tableItem.totalChairs}
                      </td>
                      <td className='text-center'>
                        <i
                          className={`${
                            tableItem.allowSmoking
                              ? 'fal fa-check-circle text-success'
                              : tableItem.isDeleted
                              ? 'fal fa-times-circle text-warning'
                              : 'fal fa-times-circle text-danger'
                          }`}
                        />
                      </td>
                      <td className='text-center'>
                        <i
                          className={`${
                            tableItem.haveHeatSystem
                              ? 'fal fa-check-circle text-success'
                              : tableItem.isDeleted
                              ? 'fal fa-times-circle text-warning'
                              : 'fal fa-times-circle text-danger'
                          }`}
                        />
                      </td>
                      <td className='text-center'>
                        <i
                          className={`${
                            tableItem.hasCoolingSystem
                              ? 'fal fa-check-circle text-success'
                              : tableItem.isDeleted
                              ? 'fal fa-times-circle text-warning'
                              : 'fal fa-times-circle text-danger'
                          }`}
                        />
                      </td>
                      <td className='text-center'>
                        <i
                          className={`${
                            tableItem.hasFogSpray
                              ? 'fal fa-check-circle text-success'
                              : tableItem.isDeleted
                              ? 'fal fa-times-circle text-warning'
                              : 'fal fa-times-circle text-danger'
                          }`}
                        />
                      </td>
                      {tableItem.inputAmount > 0 ? (
                        <td
                          className={
                            'text-center ' +
                            (tableItem.isDeleted ? 'text-warning' : '')
                          }
                        >
                          {parseInt(tableItem.inputAmount).toLocaleString()}
                        </td>
                      ) : (
                        <td
                          className={
                            'text-center ' +
                            (tableItem.isDeleted ? 'text-warning' : '')
                          }
                        ></td>
                      )}
                      <td className='text-center'>
                        <i
                          onClick={e => this.onEditItem(tableItem.itemKey)}
                          className={
                            'fal fa-edit pointer ' +
                            (tableItem.isDeleted ? 'text-warning' : '')
                          }
                        />
                      </td>
                      <td className='text-center'>
                        <Select
                          name='tableNumber'
                          className='w-full'
                          isMulti={false}
                          placeholder={
                            tableItem.isDeleted
                              ? ENUMS.CAFE_TABLE_STATUS.list[1].title
                              : ENUMS.CAFE_TABLE_STATUS.list[0].title
                          }
                          options={ENUMS.CAFE_TABLE_STATUS.list.map(status => ({
                            label: status.title,
                            value: status.value,
                          }))}
                          onChange={e =>
                            this.deleteAlreadySelectedItem(
                              e.value,
                              tableItem.itemKey,
                            )
                          }
                        />
                      </td>
                    </tr>
                  );
                })}
            <tr>
              <td colSpan='12'></td>
              <td>
                <i
                  className={`fal fa-plus-circle p-1 ${this.props.cafeType ===
                    'NORMAL' && 'pointer'}`}
                  onClick={this.props.displayAddTableItemModal}
                  title={locales('labels.add.new.table')}
                />
              </td>
            </tr>
          </tbody>
        </table>
        {this.state.displayDeleteConfirm && (
          <DeleteConfirm
            isOpen={this.state.displayDeleteConfirm}
            itemGroupTitle={locales('titles.table')}
            itemKey={this.state.selectedItemKeyForDelete}
            itemTitle={this.state.selectedItemTitleForDelete}
            onConfirm={this.deleteAlreadySelectedItem}
            closeModal={this.closeDeleteTableItemModal}
          />
        )}
      </Fragment>
    );
  }
}
